webpackJsonp([277768745375809],{

/***/ 9:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  blogPostDir: 'sample-posts', // The name of directory that contains your posts.
	  siteTitle: 'You Gotta Love Frontend Conference', // Site title.
	  twitterTitle: 'YGLF Kyiv', // Site title.
	  siteLogo: '/logo.svg', // Logo used for SEO and manifest.
	  siteUrl: 'yglf.com.ua', // Domain of your website without pathPrefix.
	  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
	  siteDescription: 'Kyiv Frontend Conference | May 24-25, 2018', // Website description used for RSS feeds/meta description tag.
	  siteRss: '/rss.xml', // Path to the RSS file.
	  siteFBAppID: '942305182583127', // FB Application ID for using app insights
	  fbPage: 'yglf.kyiv', // FB page
	  googleAnalyticsID: 'UA-107799328-1', // GA tracking ID.
	  userTwitter: 'yglf_kyiv',
	  email: 'hello@yglf.com.ua',
	  website: 'http://yglf.com.ua',
	  ticketsUrl: 'https://2event.com/events/1037785',
	  workshopWebpackUrl: 'https://2event.com/events/1230538',
	  workshopWebpackAndConfUrl: 'https://2event.com/events/1037785',
	  sitemapPages: ['/', '/about', '/speakers', '/sponsors', '/tickets', '/diversity', '/code-of-conduct']
	};

/***/ }),

/***/ 276:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SiteConfig = __webpack_require__(9);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _common = __webpack_require__(11);
	
	var _ga = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TicketsPage = function (_React$Component) {
	  _inherits(TicketsPage, _React$Component);
	
	  function TicketsPage() {
	    _classCallCheck(this, TicketsPage);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  TicketsPage.prototype.componentWillMount = function componentWillMount() {
	    (0, _ga.gaTrack)({
	      eventCategory: 'purchase',
	      eventAction: 'tickets-page-redirect',
	      eventLabel: 'tickets-page-redirect'
	    });
	  };
	
	  TicketsPage.prototype.componentDidMount = function componentDidMount() {
	    if ((0, _common.isInBrowser)()) {
	      window.location.href = _SiteConfig2.default.ticketsUrl;
	    }
	  };
	
	  TicketsPage.prototype.render = function render() {
	    return _react2.default.createElement(
	      'noscript',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        'If you are not redirected automatically, follow this ',
	        _react2.default.createElement(
	          'a',
	          { href: _SiteConfig2.default.ticketsUrl },
	          'link'
	        ),
	        '.'
	      )
	    );
	  };
	
	  return TicketsPage;
	}(_react2.default.Component);
	
	exports.default = TicketsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-tickets-js-7abcde7f09da80663b6e.js